import { FlexBox } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import React from 'react';
import { useProducts } from '../../../data-access/products/ProductsProvider';
import { useProductsQuery } from '../contexts/ProductsQueryContext';
import CategoriesBreadcrumb from './categories/CategoriesBreadcrumb';
import CategoriesList, {
  CategoriesListProps,
} from './categories/CategoriesList';
import { getFilteredCategories } from './categories/categories.utils';
import ProductsFilterForm from './products-query-filters/ProductsFilterForm';

interface ProductsQueryHeaderProps {
  renderCategoryItem?: CategoriesListProps['renderCategoryItem'];
}

const ProductsQueryHeader: React.FC<ProductsQueryHeaderProps> = ({
  renderCategoryItem,
}) => {
  const {
    productsFilter,
    availableCategories,
    isLoading,
    isLoadingLookups,
    lookupsError,
  } = useProducts();
  const { onSubmit, onCategoryClick, onBreadcrumbBackClick } =
    useProductsQuery();

  const currentCategoryLayer = getFilteredCategories(
    availableCategories,
    productsFilter
  );

  return (
    <Box
      component={'form'}
      autoComplete="off"
      noValidate
      onSubmit={onSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '100%',
      }}
    >
      <FlexBox flexDirection={'column'} gap={2}>
        <CategoriesBreadcrumb
          categories={availableCategories}
          categoryIds={productsFilter.categoryIds}
          onBreadcrumbClick={onBreadcrumbBackClick}
        />
        <ProductsFilterForm isLoading={isLoading} />
      </FlexBox>
      <CategoriesList
        categories={currentCategoryLayer}
        error={lookupsError || undefined}
        isLoading={isLoadingLookups && !isLoading}
        onCategoryClick={onCategoryClick}
        renderCategoryItem={renderCategoryItem}
      />
    </Box>
  );
};

export default ProductsQueryHeader;
